/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./small-guide.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./small-guide.component";
var styles_SmallGuideComponent = [i0.styles];
var RenderType_SmallGuideComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SmallGuideComponent, data: {} });
export { RenderType_SmallGuideComponent as RenderType_SmallGuideComponent };
export function View_SmallGuideComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["id", "small_guide_wrap"]], null, null, null, null, null)), (_l()(), i1.ɵted(1, null, ["\n    ", "\n"])), (_l()(), i1.ɵted(-1, null, ["\n"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.content; _ck(_v, 1, 0, currVal_0); }); }
export function View_SmallGuideComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-small-guide", [], null, null, null, View_SmallGuideComponent_0, RenderType_SmallGuideComponent)), i1.ɵdid(1, 4308992, null, 0, i2.SmallGuideComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SmallGuideComponentNgFactory = i1.ɵccf("app-small-guide", i2.SmallGuideComponent, View_SmallGuideComponent_Host_0, { content: "content" }, {}, []);
export { SmallGuideComponentNgFactory as SmallGuideComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/small-guide/small-guide.component.ngfactory.js.pre-build-optimizer.js